import React, { PureComponent, Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import AddAccountProfileDialog from "./AddAccountProfileDialog";
import { RouterState, routerStateToUrl } from "mobx-state-router";
import { createLocation } from "history";
import { history } from "utils/history";

import {
	Card,
	Button,
	Form,
	Select,
	Row,
	Col,
	Radio,
	Tag,
	Divider,
	Checkbox,
	Input,
	InputNumber,
	Icon,
	Popconfirm,
	Spin,
	Menu,
	Dropdown,
	Modal
} from "antd";

const Option = Select.Option;
const RadioGroup = Radio.Group;

const tailFormItemLayout = {
	wrapperCol: {
		xs: {
			span: 24,
			offset: 0
		},
		sm: {
			span: 20,
			offset: 4
		}
	}
};

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 4 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 20 }
	}
};

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class AccountForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	openAccountProfile = () => {
		let routerStore = this.props.routerStore;
		let profileId = this.props.form.getFieldValue("profileId");
		const toState = new RouterState("accounts", { id: profileId });
		const location = createLocation(routerStateToUrl(routerStore, toState));
		const href = history.createHref(location);
		window.open(href, "_blank");
	};

	render() {
		const { getFieldDecorator } = this.props.form;

		const formItemLayout = {
			labelCol: {
				xs: { span: 24 },
				sm: { span: 6 }
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 18 }
			}
		};
		const buttonItemLayout = {
			wrapperCol: { span: 8, offset: 6 }
		};
		const profileId = this.props.form.getFieldValue("profileId");

		return (
			<Form>
				<div>
					<Row>
						<Col span={18}>
							<Row>
								<Form.Item
									label="Account Profile"
									{...formItemLayout}
									help="Select or create an account profile to store
								accounts"
								>
									{this.props.form.getFieldDecorator(
										"profileId",
										{
											rules: [
												{
													required: true,
													message:
														"Please select a profile"
												}
											]
										}
									)(
										<Select
											style={{ width: 200 }}
											placeholder="Select a profile"
											disabled={!this.props.ui.editing}
											notFoundContent="Select a profile"
										>
											{this.props.profiles.map(item => {
												return (
													<Option
														value={item.id}
														key={item.id}
													>
														{item.name}
													</Option>
												);
											})}
										</Select>
									)}
								</Form.Item>
								<Form.Item {...buttonItemLayout}>
									{profileId ? (
										<Fragment>
											<Button
												type="primary"
												onClick={
													this.openAccountProfile
												}
											>
												View Profile
											</Button>
											<Divider type="vertical" />
										</Fragment>
									) : (
										""
									)}
									<Button
										type="primary"
										onClick={
											this.props
												.showAddAccountProfileDialog
										}
									>
										Add Profile
									</Button>
								</Form.Item>
								<Form.Item {...buttonItemLayout}>
									<Button
										type="primary"
										onClick={this.props.generateRandomInfo}
										loading={
											this.props.ui.generatingRandomInfo
										}
										disabled={!this.props.ui.editing}
									>
										Generate Random Info
									</Button>
								</Form.Item>
								<Form.Item
									label="First Name"
									{...formItemLayout}
								>
									{this.props.form.getFieldDecorator(
										"firstName",
										{
											rules: [
												{
													required: true,
													message:
														"Please enter first name"
												}
											]
										}
									)(
										<Input
											type="text"
											disabled={!this.props.ui.editing}
										/>
									)}
								</Form.Item>
								<Form.Item
									label="Last Name"
									{...formItemLayout}
								>
									{this.props.form.getFieldDecorator(
										"lastName",
										{
											rules: [
												{
													required: true,
													message:
														"Please enter your last name"
												}
											]
										}
									)(
										<Input
											type="text"
											disabled={!this.props.ui.editing}
										/>
									)}
								</Form.Item>
								<Form.Item label="Username" {...formItemLayout}>
									{this.props.form.getFieldDecorator(
										"username",
										{
											rules: [
												{
													required: true,
													message:
														"Username is required!"
												}
											]
										}
									)(
										<Input
											type="text"
											disabled={!this.props.ui.editing}
										/>
									)}
								</Form.Item>
								<Form.Item label="Password" {...formItemLayout}>
									{this.props.form.getFieldDecorator(
										"password",
										{
											rules: [
												{
													required: true,
													message:
														"Password is required"
												}
											]
										}
									)(
										<Input
											type="password"
											disabled={!this.props.ui.editing}
										/>
									)}
								</Form.Item>
								<Form.Item
									label="Blog Title"
									{...formItemLayout}
									help="Enter blog title. If empty, will be generated automatically"
								>
									{this.props.form.getFieldDecorator(
										"blogTitle"
									)(
										<Input
											type="text"
											disabled={!this.props.ui.editing}
										/>
									)}
								</Form.Item>
								{/* <Form.Item
									label="Blog Name"
									{...formItemLayout}
									help="Enter blog name (only numbers and letters are allowed). If empty, will be generated automatically"
								>
									{this.props.form.getFieldDecorator("blogName")(
										<Input type="text" disabled={!this.props.ui.editing} />
									)}
								</Form.Item> */}
							</Row>
							<Row />
						</Col>
					</Row>
				</div>
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class AccountTab extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { acProjectStore }
		} = this.props;

		acProjectStore.formChanged(changedFields);
	};

	addAccountProfile = payload => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		acProjectStore.addAccountProfile(payload);
	};

	showAddAccountProfileDialog = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		acProjectStore.showAddAccountProfileDialog();
	};

	hideAddAccountProfileDialog = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		acProjectStore.hideAddAccountProfileDialog();
	};

	generateRandomInfo = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		acProjectStore.generateRandomInfo();
	};

	mapPropsToFields = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;

		const profiles = acProjectStore.profiles;
		const stateForm = acProjectStore.stateForm;

		let profileExists = profiles.some(el => {
			return el.id == stateForm.profileId.value;
		});

		let profileId = profileExists
			? stateForm.profileId
			: { ...stateForm.profileId, value: undefined };
		return {
			firstName: Form.createFormField(stateForm.firstName),
			lastName: Form.createFormField(stateForm.lastName),
			password: Form.createFormField(stateForm.password),
			username: Form.createFormField(stateForm.username),
			blogTitle: Form.createFormField(stateForm.blogTitle),
			blogName: Form.createFormField(stateForm.blogName),
			profileId: Form.createFormField(profileId)
		};
	};
	render() {
		const {
			rootStore: { acProjectStore, routerStore }
		} = this.props;

		const ui = acProjectStore.ui;
		const profiles = acProjectStore.profiles;

		let addAccountProfileDialog = (
			<AddAccountProfileDialog
				ui={acProjectStore.ui}
				hideDialog={this.hideAddAccountProfileDialog}
				addAccountProfile={this.addAccountProfile}
			/>
		);

		return (
			<Fragment>
				{addAccountProfileDialog}
				<AccountForm
					routerStore={routerStore}
					fields={this.mapPropsToFields()}
					ui={ui}
					profiles={profiles}
					generateRandomInfo={this.generateRandomInfo}
					onFieldsChange={this.onFieldsChange}
					showAddAccountProfileDialog={
						this.showAddAccountProfileDialog
					}
					wrappedComponentRef={internalForm => {
						this.internalForm = internalForm;
					}}
				/>
			</Fragment>
		);
	}
}

export default AccountTab;
